<template>
  <el-main style="padding-top: 0">
    <div style="width: 96%; margin: 0 auto">
      <div class="searchBox Cf">
        <!--搜索框-->
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="今天" name="today"></el-tab-pane>
          <el-tab-pane label="昨天" name="yesterday"></el-tab-pane>
          <el-tab-pane label="本周" name="week"></el-tab-pane>
          <el-tab-pane label="本月" name="mouth"></el-tab-pane>
          <el-tab-pane label="上月" name="lastmouth"></el-tab-pane>
        </el-tabs>
        <el-form :model="form" ref="form" label-width="80px">
          <!-- <el-form-item label="关键词:">
            <el-input
              v-model="form.key"
              placeholder="登录IP/操作"
              size="mini"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="用户操作:" width="auto">
            <el-select
              v-model="operate_value"
              size="mini"
              multiple
              placeholder="请选择操作"
              collapse-tags
              clearable
              :multiple-limit="3"
            >
              <el-option
                v-for="(item, index) in operateList"
                :key="index"
                :label="item"
                :value="item"
              >
                <div
                  style="
                    max-width: 120px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ item }}
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="用户IP:">
            <el-select
              v-model="ip_value"
              size="mini"
              multiple
              placeholder="请选择IP"
              clearable
              collapse-tags
              :multiple-limit="3"
            >
              <el-option
                v-for="(item, index) in ipList"
                :key="index"
                :label="item"
                :value="item"
              >
                <div
                  style="
                    max-width: 120px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ item }}
                </div>
              </el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item
            label="选择时间段:"
            style="display: block; width: auto"
            label-width="100px"
          >
            <el-date-picker
              v-model="dateValue"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="margin-left: 10px"
              @change="
                (source) => {
                  logSelect(999);
                }
              "
              value-format="timestamp"
              align="left"
              size="mini"
            >
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="开始时间:">
            <el-date-picker
              clearable
              type="date"
              size="mini"
              placeholder="开始时间"
              v-model="form.startTime"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:">
            <el-date-picker
              clearable
              type="date"
              size="mini"
              placeholder="结束时间"
              v-model="form.endTime"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label-width="0" style="display: block;width: auto">
            <el-button
              type="primary"
              style="background-color: #1577d2; margin-left: 10px"
              @click="search"
              size="mini"
              >查询</el-button
            >
          </el-form-item> -->
        </el-form>
        <el-button
          type="primary"
          style="background-color: #1577d2; margin-left: 10px; margin-top: 5px"
          @click="search"
          size="mini"
          >查询</el-button
        >
      </div>
      <div class="customerList">
        <div style="padding: 5px 10px">
          <div style="font-size: 16px; line-height: 20px; margin-bottom: 10px">
            选择坐席<span style="color: #a7a7a7">（不选默认所有）</span> ：
          </div>
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="checkedList"
            @change="handleCheckedChange"
          >
            <el-checkbox
              style="width: 100px"
              v-for="customer in customerList"
              :label="customer.id"
              :key="customer.id"
              >{{ customer.realName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div>
        <el-table
          style="width: 100%; margin-top: 15px"
          :data="logLst"
          border
          highlight-current-row
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          stripe
          :max-height="tableHeight"
        >
          <el-table-column property="userName" label="登录账号" width="140">
          </el-table-column>
          <el-table-column property="model" label="模块" width="150">
          </el-table-column>
          <el-table-column property="option" label="具体操作">
          </el-table-column>
          <el-table-column property="ip" label="登录IP" width="170">
          </el-table-column>
          <el-table-column property="createTime" label="时间" width="200">
          </el-table-column>
        </el-table>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          width: 60%;
          margin-left: 20%;
          justify-content: space-around;
          margin-top: 15px;
        "
      >
        <el-pagination
          background
          :pager-count="9"
          :page-size="10"
          layout="prev, pager, next, total"
          :total="total"
          @prev-click="pre"
          @next-click="next"
          :current-page="page"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      input1: "",
      logLst: [],
      total: 0,
      page: 1,
      form: {
        key: "",
        startTime: "",
        endTime: "",
      },
      startTime: "",
      endTime: "",
      keySearch: "",
      customerList: [],
      isIndeterminate: false,
      checkAll: false,
      checkedList: [],
      activeName: "today",
      value1: "",
      tableHeight: 400,
      dateValue: [
        new Date(new Date().toLocaleDateString()),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
      ],
      ip_value: [],
      operate_value: [],
      ipList: [],
      operateList: [],
    };
  },
  created() {},
  mounted() {
    // const site = JSON.parse(localStorage.getItem("siteObj"));
    var start = new Date(new Date().toLocaleDateString()).getTime();
    this.form.startTime = this.util.timeStampToDate(start, 0);
    var end = Date.parse(new Date());
    this.form.endTime = this.util.timeStampToDate(end, 0);
    this.logSelect();
    this.getCurrentDepartBelowUsers();
    this.getIpAndoperateList();
    this.$nextTick(() => {
      var seaH = $(".searchBox").height();
      var cusH = $(".customerList").height();
      this.tableHeight = window.innerHeight - seaH - cusH - 180;
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
        var seaH = $(".searchBox").height();
        var cusH = $(".customerList").height();
        this.tableHeight = window.innerHeight - seaH - cusH - 180;
      });
    });
  },
  watch: {
    value1: function (newVal) {
      console.log(111111111111, newVal);
    },
  },
  methods: {
    async getIpAndoperateList() {
      const api = "/manager/optionlog/choice";
      let promise = [];
      for (let i = 0; i < 2; i++) {
        promise.push(
          this.util.postRequest({
            url: api,
            method: "POST",
            data: {
              startTime: this.form.startTime,
              endTime: this.form.endTime,
              flag: i,
              size: 10,
              current: 1,
            },
          })
        );
      }
      this.ip_value = [];
      this.operate_value = [];
      const res = await Promise.all(promise);
      if (res[0].resultCode == 10000) {
        this.ipList = res[0].data;
      }
      if (res[1].resultCode == 10000) {
        this.operateList = res[1].data;
      }
    },

    async logSelect(source) {
      if (source === 999) {
        this.activeName = "";
        this.page = 1;
        console.log("this.dateValue-----------", this.dateValue);
        if (this.dateValue === null) {
          this.dateValue = [];
        } else {
          this.form.startTime = this.util.timeStampToDate(
            new Date(this.dateValue[0]).getTime(),
            0
          );
          this.form.endTime = this.util.timeStampToDate(
            new Date(this.dateValue[1]).getTime(),
            0
          );
        }
        this.getIpAndoperateList();
      }
      var api = "/manager/optionlog/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          current: this.page,
          size: 10,
          type: "ALL",
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          keySearch: this.form.key,
          ips: this.ip_value,
          options: this.operate_value,
          csIds: this.checkedList,
        },
      });

      console.log("logSelect response = ", response.data);
      this.logLst = response.data.optionLogVoList;
      if (this.logLst != null || this.logLst != []) {
        for (var i = 0; i < this.logLst.length; i++) {
          if (
            this.logLst[i].updateTime != null ||
            this.logLst[i].updateTime != undefined
          ) {
            var end2 = this.util.timeStampToDate(this.logLst[i].updateTime, 0);
            this.logLst[i].createTime = end2;
          } else {
            if (
              this.logLst[i].createTime != null ||
              this.logLst[i].createTime != undefined
            ) {
              var end1 = this.util.timeStampToDate(
                this.logLst[i].createTime,
                0
              );
              this.logLst[i].createTime = end1;
            }
          }
        }
      }
      this.total = response.data.total;
      console.log(this.logLst);
    },
    async getCurrentDepartBelowUsers() {
      var api = "/manager/user/getCurrentDepartBelowUsers";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log(
        "reportStatistics getCurrentDepartBelowUsers response ===> ",
        response
      );

      if (response.resultCode === "10000") {
        this.customerList = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },
    headerStyle() {
      return "text-align:left;padding:15px;";
    },
    cellStyle() {
      return "text-align:left;padding:15px;";
    },
    pre(info) {
      console.log("pre：", info);
      this.page = info;
      this.logSelect();
    },
    next(info) {
      console.log("next：", info);
      this.page = info;
      this.logSelect();
    },
    handleCurrentChange(val) {
      console.log("当前页码：", val);
      this.page = val;
      this.logSelect();
    },
    search() {
      this.page = 1;
      console.log("search", this.form);
      this.logSelect();
    },
    handleCheckAllChange(val) {
      if (val === true) {
        for (var i = 0; i < this.customerList.length; i++) {
          this.checkedList.push(this.customerList[i].id);
        }
      } else {
        this.checkedList = [];
      }
      this.logSelect();
    },
    handleCheckedChange() {
      this.page = 1;
      console.log(
        "LoggingManager handleCheckedChange checkedList",
        this.checkedList
      );
      this.logSelect();
    },
    handleClick(tab) {
      var name = tab.name;
      var start;
      var end;
      var now = new Date();
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      console.log(111111111, nowDayOfWeek);
      var nowDay = now.getDate(); //当前日
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += nowYear < 2000 ? 1900 : 0; //
      var lastMonthDate = new Date(); //上月日期
      if (nowDayOfWeek === 0) {
        nowDayOfWeek = 7;
      }
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      // var lastYear = lastMonthDate.getYear();
      var lastMonth = lastMonthDate.getMonth();

      if (name === "today") {
        start = new Date(new Date().toLocaleDateString()).getTime();
        this.form.startTime = this.util.timeStampToDate(start, 0);
        end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.form.endTime = this.util.timeStampToDate(end, 0);
      } else if (name === "yesterday") {
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          24 * 60 * 60 * 1000;
        this.form.startTime = this.util.timeStampToDate(start, 0);
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        this.form.endTime = this.util.timeStampToDate(end, 0);
      } else if (name === "week") {
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
        this.form.startTime = this.formatDate(start) + " 00:00:00";
        end = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
        this.form.endTime = this.formatDate(end) + " 23:59:59";
      } else if (name === "mouth") {
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        var monthEndDate = new Date(nowYear, nowMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24); //本月天数
        start = new Date(nowYear, nowMonth, 1);
        //this.form.startTime = start;
        this.form.startTime = this.formatDate(start) + " 00:00:00";
        end = new Date(nowYear, nowMonth, days);
         this.form.endTime = this.formatDate(end) + " 23:59:59"; //返回当月结束时间
        //this.form.endTime = new Date(new Date(end).getTime() - 1);
      } else if (name === "lastmouth") {
        var lastMonthStartDate1 = new Date(nowYear, lastMonth, 1);
        var lastMonthEndDate1 = new Date(nowYear, lastMonth + 1, 1);
        var days1 =
          (lastMonthEndDate1 - lastMonthStartDate1) / (1000 * 60 * 60 * 24);
        start = new Date(nowYear, lastMonth, 1);
        this.form.startTime = this.formatDate(start) + " 00:00:00";
        end = new Date(nowYear, lastMonth, days1);
        this.form.endTime = this.formatDate(end) + " 23:59:59";
      }
      // 为日期时间选择器赋值
      this.util.handleGetTime(
        this.form.startTime,
        this.form.endTime,
        this.dateValue
      );
      console.log(
        "reportStatistics handleClick date",
        name,
        this.form.startTime,
        this.form.endTime
      );
      this.page = 1;
      this.logSelect();
      this.getIpAndoperateList();
    },
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
  },
};
</script>

<style lang="scss" scoped>
.timeTap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 15px;
  width: 90%;
}

.searchBox :deep() {
  .el-form-item {
    width: auto !important;

    input {
      width: 200px !important;
    }
  }
  .el-select__tags {
    // overflow-x: auto;
    flex-wrap: nowrap;
    width: auto;
 

    // &::-webkit-scrollbar {
    //   width: 1px;
    //   height: 2px;
    //   background-color: #f1f1f1;
    // }
    // &::-webkit-scrollbar-thumb {
    //   background: red;
    //   border-radius: 10px;
    //   height: 2px;
    // }
  }
  .el-tabs__item {
    min-width: 46px;
    height: 30px;
    line-height: 30px;
    padding: 0 10px !important;
    text-align: center;
    @include change_size($font_size_normal);
  }
  .el-tabs__header {
    border-bottom: 1px solid #ffffff !important;
    margin: 0;
  }
  .el-tabs__item.is-active {
    border-bottom-color: #1577d2 !important;
    background-color: #1577d2;
    color: #fff;
  }
  .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
    margin-top: 5px;
    // margin-right: 15px;
  }
  .el-tabs,
  .el-tabs--card,
  .el-tabs--top {
    // width: 227px;
    float: left;
  }
}
.inputCss :deep() {
  .el-input__inner {
  }
  .el-input--suffix .el-input__inner {
    padding-right: 5px;
  }
}
.customerList {
  max-height: 140px;
  overflow: auto;
  border: 1px solid #ffffff;
  box-shadow: 0px 0px 4px 0px #d3d4de;
  // padding: 5px 10px;
  width: 100%;
}
</style>
